import angular from "angular";
import { calcReportType, Calculation, Calculations } from "@salaxy/core";
import { UiHelpers } from "../../services";

/**
 * Handles user interaction for displaying calculation
 */
export class CalcReportsDisplayController implements angular.IController {
  public static $inject = [
    "UiHelpers",
    "Calculations"
  ];
  /**
   * Creates a new instance of CalcReportsDisplayController
   * @param uiHelpers - Salaxy ui helpers service.
   */
 constructor(
  private uiHelpers: UiHelpers,
  private calculations: Calculations
) {}

/**
 * Display CalcReports
 * @param reportType Report type
 * @param calculation BusinessObject
 */
public display(reportType: calcReportType, calculation: Calculation): void {
    const calcs: Calculation[] = [calculation];
    const data = {
      reportType,
      calcs,
    };

    this.uiHelpers.showDialog(
      "salaxy-components/modals/calc/CalcReports.html",
      null,
      data,
      null,
      "lg",
      true);
  }

/**
 * Display CalcReports
 * @param reportType Report type
 * @param calculationId BusinessObject id
 */
public async displayForId(reportType: calcReportType, calculationId: string): Promise<void> {
    const calculation = await this.calculations.getSingle(calculationId);
    const calcs: Calculation[] = [calculation];
    const data = {
      reportType,
      calcs,
    };

    this.uiHelpers.showDialog(
      "salaxy-components/modals/calc/CalcReports.html",
      null,
      data,
      null,
      "lg",
      true);
  }
}